import { render, staticRenderFns } from "./BookingSidebar.vue?vue&type=template&id=f8b57ef0"
import script from "./BookingSidebar.vue?vue&type=script&lang=js"
export * from "./BookingSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports